import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
    padding: 24px;
    border-radius: 8px;
`;

export const Headline = styled.div`
    ${(props) => css(props.theme.typography.Subheadline)};
    color: ${({ theme }) => theme.colors.secondary};
    margin-bottom: 16px;
`;

export const Description = styled.div`
    ${(props) => css(props.theme.typography.Paragraph)};
    color: ${({ theme }) => theme.colors.secondary};
    a {
        color: ${({ theme }) => theme.colors.secondary};
        text-decoration: underline;
    }
`;
